import { gql } from "@apollo/client"; import { useQuery } from "@apollo/client/react"; import React, {
  useContext,
  useEffect,
  useState,
  cloneElement,
  memo
} from
  'react';
import { useTranslation } from 'react-i18next';
import Header from '../../Pages/Menu/Header';
import NavBar from '../../Pages/Menu/NavBar';
import { Context, KpiContext } from '../../context/context';
import Container from '@mui/material/Container';
import { Breadcrumbs } from '../breadcrumbs/Breadcrumbs';
import { routeGenerator } from '../breadcrumbs/routeGenerator';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import { useGetBreakpoints } from '../../responsiveTools/breakpoints';
import ProfileSection from '../../Pages/Menu/Header/ProfileSection';
import { DesktopOrTabletContainer, MobileContainer } from '../../responsiveTools/ResponsiveContainers';
import './mainContent.scss';

import { MobileSwipeModal } from '../mobileSwipeModal/MobileSwipeModal';
import { Dialog, Grid, IconButton } from '@mui/material';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import styled from "@mui/system/styled";
import KpiDesktop from '../kpiDesktop/KpiDesktop';

// Kpistemp
const idUsuario = parseInt(sessionStorage.getItem("idUsuario"), 10);
const GET_USER_KPI = gql`
    query QGetKpisUsuario ($idUsuario: Int!) {
        kpisUsuario (idUsuario: $idUsuario)
        {
            success,
            error,
            valorEsperado {
                nombre,
                descripcion,
                valor,
                icono,
                link,
                iframe
            }
        }
    }`;

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-container": {
    alignItems: "flex-start",
    marginTop: '30px'
  }
}));


const MainContent = memo(function MainContent({
  titulo,
  component,
  noBackground,
  roundedBottomOnly,
  mainContentWhite,
  tableMaxWidth,
  renderIframe,
  labelBottom,
  customSectionTitle,
  titleCondensed // Prop usada para cuando necesitamos que el "children" ocupe todo el espacio disponible
}) {
  const [context] = useContext(Context);
  const [kpiContext, setKpiContext] = useContext(KpiContext);
  const [childrenAction, setChildrenAction] = useState(null);
  const [headerContent, setHeaderContent] = useState(null);
  const [footerContent, setFooterContent] = useState(null);
  const [routesData, setRoutesData] = useState([]);
  const [allowedWrite, setAllowedWrite] = useState(false);
  const [showArrowBack, setShowArrowBack] = useState(false);
  const [kpiData, setKpiData] = useState([]);

  const location = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const headerTitle = t(titulo);
  const { isMobile } = useGetBreakpoints();

  const { loading, data } = useQuery(GET_USER_KPI, {
    variables: { idUsuario: idUsuario }
  });

  useEffect(() => {
    let isMounted = true;

    if (data?.kpisUsuario?.valorEsperado && isMounted) {
      setKpiData(data.kpisUsuario.valorEsperado);
    }

    return () => { isMounted = false; }; // Cleanup para evitar updates en un componente desmontado
  }, [data]); // Se ejecuta solo cuando 'data' cambia

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const routes = localStorage.getItem('navigationRoutes');
    if (routes) {
      const rutas = JSON.parse(routes);
      const rutaQueSirve = location.pathname;
      const pantallaActual = rutas?.find((ruta) => ruta.aplicaciones.find((app) => app.url == rutaQueSirve))?.aplicaciones?.find((app) => app.url == rutaQueSirve); 
      
      if(pantallaActual?.idApp > 0){
        setAllowedWrite(pantallaActual.escritura);
      }
      
      const generatedRoutes = routeGenerator(rutas, location);
      setRoutesData(generatedRoutes?.breadcrumbs);
      setShowArrowBack(generatedRoutes?.showBackArrow);
    }
  }, [location]);

  return (
    <>
      <Header />
      <div className='page-container'>
        {context ? <NavBar iFrame={renderIframe} /> : ""}
        <div className='head-content'>
          <div className={`main-content-container ${isMobile ? 'main-content-container-mobile-mode' : ''}`}>
            <div className="content-action-container">
              <MobileContainer>
                <div className='mobile-header-container'>
                  <div className='mobile-section-header'>
                    <div className="mobile-user-section" style={{ visibility: showArrowBack ? 'visible' : 'hidden' }}>
                      <IconButton onClick={() => navigate(-1)} >
                        <ArrowBackIosRoundedIcon className='mobile-arrow-back' />
                      </IconButton>
                    </div>
                    <span className='mobile-section-title'>
                      {/* Si se debe mostrar la flecha es porque se ingreso un subnivel abajo en las rutas */}
                      {!customSectionTitle && !showArrowBack && routesData.at(0)}
                      {!customSectionTitle && routesData.at(-1)}
                      {!!customSectionTitle && customSectionTitle}
                    </span>
                    <div className='mobile-user-section'>
                      <ProfileSection />
                    </div>
                  </div>
                  {headerTitle && <h2 className={`content-title ${isMobile ? 'mobile-size' : ''}`}>{headerTitle}</h2>}
                </div>
              </MobileContainer>
              <DesktopOrTabletContainer>
                <Breadcrumbs routes={routesData} />
                <div className='content-action-row'>
                  <div className={`back-container ${titleCondensed ? 'title-condensed' : ''}`}>
                    {showArrowBack &&
                      <ChevronLeftIcon
                        className='arrow-back'
                        onClick={() => navigate(-1)} />

                    }
                    <h2 className={`content-title`}>{headerTitle}</h2>
                  </div>
                  {Boolean(childrenAction) && childrenAction}
                </div>
                {labelBottom && <p style={{ fontSize: 14 }}> {labelBottom}</p>}
              </DesktopOrTabletContainer>
            </div>
            {Boolean(headerContent) && headerContent}
            {!renderIframe &&
              <div className={`
                        ${mainContentWhite ? 'main-content-white' : 'main-content'}
                        ${roundedBottomOnly ? 'rounded-top-border' : 'regular-border-radius'}
                        ${noBackground && !isMobile && 'no-background'}
                        ${isMobile ? !!headerTitle ? 'mobile-padding' : 'no-title-mobile-padding' : 'default-padding'}
                        `}>

                {cloneElement(component,
                  {
                    ...component.props,
                    allowedWrite,
                    setChildrenAction,
                    setHeaderContent,
                    setFooterContent
                  })}
              </div>
            }
            {Boolean(footerContent) && footerContent}
            {renderIframe && component}
          </div>
        </div>
      </div>
      <MobileSwipeModal
        title={'Metricas'}
        open={kpiContext === 'block'}
        onClose={() => setKpiContext('none')}>

        <Grid
          className='kpi-main-section'
          container
          columns={1}
          justifyContent='flex-start'>

          {kpiData?.map((kpi) =>
            <Grid key={kpi.nombre} size={{ xs: 1 }}>
              <div className='kpi-column'>
                <span className='kpi-header'>
                  {kpi.nombre}
                </span>
                <div className='kpi-row'>
                  <PersonOutlineOutlinedIcon className='kpi-icon' />
                  <span className='kpi-value'>
                    {kpi.valor}
                  </span>
                </div>
              </div>
            </Grid>
          )}
        </Grid>
      </MobileSwipeModal>

      <DesktopOrTabletContainer>
        <KpiDesktop />
      </DesktopOrTabletContainer>
    </>);

});

export default MainContent;